import NeedCaptureContent from './components/content';
import { NeedCaptureProvider } from './state';

interface Props {
  petType: 'cat' | 'dog';
}

/**
 * Wrapper for the need capture component that provides the context.
 */
const NeedCapture: React.FC<Props> = ({ petType }) => (
  <NeedCaptureProvider>
    <NeedCaptureContent petType={petType} />
  </NeedCaptureProvider>
);

export default NeedCapture;
